import { InformationCircleIcon } from '@heroicons/react/20/solid';
import React from 'react';

import { cn } from './cn';
import { Tooltip } from './Tooltip';

export interface InfoTextProps {
  children: React.ReactNode;
  /** Render as tooltip instead of inline text */
  asTooltip?: boolean;
  className?: string;
  iconClassName?: string;
}

export const InfoText = ({ children, asTooltip = false, className, iconClassName }: InfoTextProps) => {
  if (asTooltip) {
    return (
      <Tooltip content={children} interactive>
        <span
          className={cn(
            'inline-flex cursor-help text-gray-400 hover:text-info-500 transition-colors duration-150',
            iconClassName
          )}
        >
          <InformationCircleIcon className="h-4 w-4" />
        </span>
      </Tooltip>
    );
  }

  return (
    <div className={cn('flex items-start gap-2 text-sm text-gray-500', className)}>
      <InformationCircleIcon className={cn('align-first-line-4 text-gray-400', iconClassName)} />
      <span>{children}</span>
    </div>
  );
};
